import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Space, Spin, Table, Typography, message } from 'antd';
import { renderExperimentsApi } from '../services/catalogServiceAPI/renderExperimentsProxy';
import { StatusTag, experimentTotals, formatDate } from './shared';

const { Title, Text } = Typography;

export function RenderExperiments() {
    const history = useHistory();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        renderExperimentsApi.list()
            .then(setItems)
            .catch((e) => message.error(e.message))
            .finally(() => setLoading(false));
    }, []);

    const columns = [
        { title: 'Name', dataIndex: 'name', render: (name, r) => <a onClick={() => history.push(`/experiments/${r.id}`)}>{name}</a> },
        { title: 'Status', dataIndex: 'status', width: 110, render: (s) => <StatusTag status={s} /> },
        { title: 'Arms', width: 220, render: (_, r) => r.arms.map((a) => a.label).join(' · ') },
        { title: 'Sources', width: 90, render: (_, r) => r.progress.sources || r.sourceCount },
        {
            title: 'Generated', width: 130,
            render: (_, r) => {
                const t = experimentTotals(r);
                return t.total ? `${t.done}/${t.total}${t.failed ? ` (${t.failed} failed)` : ''}` : '—';
            },
        },
        { title: 'Votes', dataIndex: ['progress', 'votes'], width: 80 },
        { title: 'Created', dataIndex: 'createdAt', width: 170, render: formatDate },
        {
            title: '', width: 220,
            render: (_, r) => (
                <Space>
                    <Button size="small" onClick={() => history.push(`/experiments/${r.id}`)}>Open</Button>
                    <Button size="small" disabled={r.status === 'draft'} onClick={() => history.push(`/experiments/${r.id}/rate`)}>Rate</Button>
                    <Button size="small" disabled={r.status === 'draft'} onClick={() => history.push(`/experiments/${r.id}/results`)}>Results</Button>
                </Space>
            ),
        },
    ];

    return (
        <div style={{ padding: 24 }}>
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <Title level={3} style={{ margin: 0 }}>Render Experiments</Title>
                        <Text type="secondary">Compare providers, models or prompts on real user renders, blind-ranked by raters.</Text>
                    </div>
                    <Button type="primary" onClick={() => history.push('/experiments/new')}>New experiment</Button>
                </div>
                {loading ? <Spin /> : <Table dataSource={items} columns={columns} rowKey="id" size="small" pagination={false} />}
            </Space>
        </div>
    );
}
